import { XBRL_FILES_URL } from '../constants/route-paths';

/**
 * The toast line shown when a conversion-progress event arrives (Phase 1 or 2).
 *
 * ## Why the link goes to the XBRL Files listing, never to the filing page
 *
 * The event fires while the conversion is, in all likelihood, still
 * `InProgress`. An in-progress (or failed) conversion is not meant to be opened
 * (P.O., 2026-10-14) — the listing withholds its click for exactly that reason
 * — and `retrieve-mbrs-data` answers `409 MBRS_DATA_NOT_READY` for it. Linking
 * straight to `/mbrs/filing?id=…` sent the user into a filing page that could
 * only fail. The listing is where the conversion becomes clickable once it is
 * ready, so that is where this points.
 *
 * Only the file name is interpolated; it was the anchor's text before and is the
 * only identifying detail the toast needs. The old link also carried the
 * conversion id, company name and file name in a query string, none of which
 * the listing reads.
 */
export function buildConversionProgressToastSummary(fsFileName: string): string {
  return `<a href='${XBRL_FILES_URL}' class='text-[#0b8ebb] cursor-pointer'>${fsFileName}</a> was uploaded successfully. Please review the initial fields mapped and edit if necessary to proceed with full template generation and mapping.`;
}
